import React from 'react';
import { FaXTwitter, FaLinkedinIn, FaYoutube, FaInstagram } from 'react-icons/fa6';
import Logo from './ui/Logo';
import { NAV_LINKS, APP_URL } from '../constants';

const LEGAL = ['Privacy', 'Terms', 'Support', 'Contact'];
const SOCIALS = [FaXTwitter, FaLinkedinIn, FaYoutube, FaInstagram];

const Footer = () => (
  <footer className="bg-[#05040a] text-white border-t border-white/5" data-testid="footer">
    <div className="mx-auto max-w-7xl px-6 py-10 flex flex-col lg:flex-row lg:items-center gap-8 justify-between">
      <Logo tagline />
      <nav className="flex flex-wrap gap-x-7 gap-y-3">
        {NAV_LINKS.map((l) => (
          <a key={l.name} href={l.href} className="text-sm text-white/60 hover:text-white transition-colors" data-testid={`footer-link-${l.href.slice(1)}`}>{l.name}</a>
        ))}
      </nav>
      <div className="flex items-center gap-6">
        {LEGAL.map((l) => (
          <a key={l} href={APP_URL} className="text-xs text-white/50 hover:text-white transition-colors" data-testid={`footer-legal-${l.toLowerCase()}`}>{l}</a>
        ))}
        <div className="flex gap-4 ml-2">
          {SOCIALS.map((Icon, i) => (
            <a key={i} href="#top" aria-label="social" className="text-white/70 hover:text-white transition-colors" data-testid={`footer-social-${i}`}><Icon size={18} /></a>
          ))}
        </div>
      </div>
    </div>
    <p className="text-center text-xs text-white/40 pb-8">&copy; {new Date().getFullYear()} LoopAI. All rights reserved.</p>
  </footer>
);

export default Footer;
